import qs from 'querystring'
 
import _ from 'underscore'
import Api from '../lib/request'
import cookie from '../lib/cookie'
import COOKIECONSTANT from '../constant/cookie'

const getRechargeDetail = (options) => {
  return new Promise((resolve, reject) => {
    const query = _.isEmpty(options) ? `` : `?${qs.stringify(options)}`
    const url = `${COOKIECONSTANT.REQUEST_HOST}${query}`
    Api.get(url, {
      headers: {
        'X-Host': 'mall.recharge-product.info',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
      }
    }).then((data) => {
      if (data.status !== 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    }, (e) => {
      reject(e)
    })
  })
}
const getRecommendProduct = (queryData) => {
  return new Promise((resolve, reject) => {
    Api.get(COOKIECONSTANT.REQUEST_HOST, {
      headers: {
        'X-Host': 'mall.cfg.popular.product.list',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN)
      }
      })
      .then((data) => {
        resolve(data)
      }, (e) => {
        reject(e)
      })
  })
}
export default {
  getRechargeDetail,
  getRecommendProduct,
}
